import Dashboard from "./Dashboard";
import ReceivedInvoice from "./ReceivedInvoice";


export default [
    {
        name: "app.dashboard",
        path: "/dashboard",
        component: Dashboard,
        meta: { requiresAuth: true }
    },
    {
        name: "app.received",
        path: "/received",
        component: ReceivedInvoice,
        meta: { requiresAuth: true }
    },
  ];